// extracted by mini-css-extract-plugin
export default {"payButton":"b4ftld","payButtonContainer":"eX4AlD"};